module.exports = __webpack_public_path__ + "img/prizeloading.6e69b4c0.png";